import ZkResource from './src/main'
ZkResource.install = function (Vue) {
  Vue.component(ZkResource.name, ZkResource)
}
export default ZkResource



// WEBPACK FOOTER //
// ./src/cdpBase/baseComponents/resource/index.js